import { ApiClientError } from '@/lib/api/client'

export const COLLABORATOR_EMAIL_TAKEN_MESSAGE =
  'Este e-mail já está em uso na plataforma. Cada e-mail só pode ter um acesso de instituição ou colaborador.'

const LEGACY_COLLABORATOR_ERROR_MESSAGES: Record<string, string> = {
  'The email has already been taken.': COLLABORATOR_EMAIL_TAKEN_MESSAGE,
  'The email has already been taken': COLLABORATOR_EMAIL_TAKEN_MESSAGE,
  'Erro de validação': 'Não foi possível salvar. Confira os dados e tente de novo.',
  'Validation failed.': 'Não foi possível salvar. Confira os dados e tente de novo.',
  'Validation failed': 'Não foi possível salvar. Confira os dados e tente de novo.',
  'The given data was invalid.': 'Não foi possível salvar. Confira os dados e tente de novo.',
  'Collaborator deleted successfully.': 'Colaborador excluído com sucesso.',
  'Unauthenticated.': 'Sessão expirada. Faça login novamente.',
  Unauthenticated: 'Sessão expirada. Faça login novamente.',
}

export type CollaboratorFormField = 'name' | 'email' | 'password' | 'permissions' | 'is_active'

export interface CollaboratorOperationError {
  message: string
  fieldErrors: Partial<Record<CollaboratorFormField, string>>
}

function isCollaboratorFormField(value: string): value is CollaboratorFormField {
  return (
    value === 'name' ||
    value === 'email' ||
    value === 'password' ||
    value === 'permissions' ||
    value === 'is_active'
  )
}

export function mapCollaboratorErrorMessage(message: string): string {
  const trimmed = message.trim()
  return LEGACY_COLLABORATOR_ERROR_MESSAGES[trimmed] ?? trimmed
}

export function getCollaboratorOperationError(error: unknown): CollaboratorOperationError {
  if (error instanceof ApiClientError) {
    const fieldErrors: Partial<Record<CollaboratorFormField, string>> = {}

    if (error.errors) {
      for (const [key, messages] of Object.entries(error.errors)) {
        if (!isCollaboratorFormField(key)) continue
        const first = messages[0]
        if (first) {
          fieldErrors[key] = mapCollaboratorErrorMessage(first)
        }
      }
    }

    const fieldMessage =
      fieldErrors.email ?? fieldErrors.name ?? fieldErrors.password ?? fieldErrors.permissions

    const mappedMessage = mapCollaboratorErrorMessage(error.message || '')
    const message =
      fieldMessage ||
      mappedMessage ||
      'Não foi possível concluir a operação. Tente de novo em instantes.'

    return { message, fieldErrors }
  }

  if (error instanceof Error && error.message.trim() !== '') {
    return {
      message: mapCollaboratorErrorMessage(error.message),
      fieldErrors: {},
    }
  }

  return {
    message: 'Não foi possível concluir a operação. Tente de novo em instantes.',
    fieldErrors: {},
  }
}
